import React, { createContext } from 'react'
import { BaseContextState, BaseContextProvider } from '../BaseContext'
import ISex from '../../interfaces/ISex'
import { SearchRequest } from '../../services/api/interfaces/ApiRequest'
import { sexList } from '../../services/api'

interface SexContextState extends BaseContextState {
  sexs: Array<ISex> | null
}

interface SexContextData extends SexContextState {
  resetErrors: Function,
  requestSexList: (args: SearchRequest) => void,
}

// Create context
const { Provider, Consumer } = createContext({} as SexContextData)

// Export consumer
export const SexConsumer = Consumer

export class SexProvider extends BaseContextProvider {
  state: SexContextState = {
    sexs: null
  }

  /**
   * Make api request for sex list
   * 
   * @param {SearchRequest} payload 
   */
  requestSexList = (payload: SearchRequest) => {
    this.setState({
      fetching: true,
      error: null
    }, async () => {
      const response = await sexList(payload)

      // Process our response
      this.processResponse(response, { 
        paginate: {
          destination: 'sexs'
        },
      })
    })
  }

  render() {
    return (
      <Provider
        value={{
          // States
          ...this.state,

          // Dispatches
          resetErrors: this.resetErrors,
          requestSexList: this.requestSexList
        }}
      >
        {this.props.children}
      </Provider>
    )
  }
}
